import { Component, OnInit,ViewChild } from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import { ThrowStmt } from '@angular/compiler';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { nodeChildrenAsMap } from '@angular/router/src/utils/tree';
import { theme } from 'highcharts';
import { ViewmodalReportComponent } from '../viewmodal-report/viewmodal-report.component';
import { element } from 'protractor';
import { isNullOrUndefined } from 'util';
import { EncdecService } from 'src/app/services/encdec.service';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

@Component({
  selector: 'app-statemeeting-reports',
  templateUrl: './statemeeting-reports.component.html',
  styleUrls: ['./statemeeting-reports.component.css']
})
export class StatemeetingReportsComponent implements OnInit {
  @ViewChild('meetingModal',{})meetingModal;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  yearList:any = [
    { key: '2021', value: '2021-2022'},
    { key: '2022', value: '2022-2023'},
    { key: '2023', value: '2023-2024'}
  ];
  modeList = [
    {key:'monthwise',value:'Month Wise'},
    {key:'reportsummary',value:'Report Summary'},
    // {key:'consolidatedreport',value:'Consolidated Report'},
    {key:'abstractreport',value:'Abstract Report'}
  ]
  statehierachyDataList : object = {AssesmentList:{},StateList:[],DistrictList:[]};
  userdetails = {};
  statename : any;
  public viewPort: CdkVirtualScrollViewport;
  selectedstate : any;
  selecteddistrict : any;
  editweightfilter: object = {'ay':"",'lu':"","month":"","stateuuid":""};
  validation : object = {ay : true,state:true,district:true,month:true};
  stateArrayList: any[];
  statelists: any[];
  distrctentityList: any[];
  filterdistrict: any;
  showdistdrop: boolean;
  showtabledata: boolean;
  showAttendence:boolean;
  activeSpinner: boolean;
  subindicatorlabel={
    "4969624b-435f-4b84-869e-4b231154dea9" : "NMCG Activity calendar is followed",
    "b74879e3-8ee9-4680-ae9e-6bd26fcf8deb" : "Mass awareness meetings held (If Yes- No of meetings held)",
    "927f32ce-8fbd-41cb-b262-090a7aef783d" : "Conduct of Melas",
    "e9ac85d7-394c-4bb1-a720-50fe0ef8a238" : "Plantation Activity",
    "f64406cf-3c8a-448d-8e81-572a02b9d8c2" : "Other - Mention It - Like Ganga Run, Painting Competetion",
    "d022918e-1279-4cb7-b5de-033848481f63" : "Press Release Items",
    "17d950b4-8908-407e-be5c-65ae59fe0bd9" : "No of Social Media Post By DGC - Facebook, Twitter, Youtube",
  }
  modes={
    monthwise: "Month Wise",
    // statewise: "State Wise",
    reportsummary: "Report Summary",
    // consolidatedreport: "Consolidated Report"
  }
  monthsList: any;
  selectedMonth: any;
  selectedMode: any;
  reportsdata: any;
  hierarchyData = [];
  tableData: any[];
  showbuttons: boolean;
  fetchweights: any = [];
  labelData: any = [];
  childList: any[];
  yearDropDownList: any;
  availabledistdata: any[];
  modalRef: any;
  districtid: any;
  loginDetails: any[];
  fetchdistricts: any;
  monthLabel: any;
  attendenceReport:any
  modalReference: any;
  clickableData: any;
  currentMonthVar: any;
  currentYearVar: number;
  isDescending: boolean;
  showDrop: any;
  selectedFilter: any;
  fetchReport: any[];
  parseobj:any;
  selectedYear: any;
  abstractRepData: any;
  abstractYear: any;
  dgcCount: any;


  constructor(public tableconstants : TableConstantsModule,
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private modalService: NgbModal,
    private logsrv : AuthloginService,
    private encdecservice : EncdecService,
    private toastr : ToastrService,) { }
    ngOnInit() {
      this.submitdataSerivce.getStatusOfToken();
      this.getdynamicYears();
      this.getstateslist();
      this.initializeOnStateLoad(null);
    }
    initializeOnStateLoad(call){
      this.loginDetails = [];
      this.userdetails = this.logsrv.checkloginstatus();
      if(this.logsrv.checkloginstatus()){
        this.userdetails = this.logsrv.checkloginstatus();
         this.userdetails['login'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY,this.userdetails['login']); 
      }
      this.monthsList = this.monthList;
      // this.yearDropDownList = this.submitdataSerivce.getassesmentYear();
      // this.editweightfilter['ay'] = this.yearDropDownList[this.yearDropDownList.length-1];
      this.setCurrentMonthDefault();
    }
    getdynamicYears(){
      let date = new Date();
      let currentYear = date.getFullYear();
      let currentmonth = date.getMonth();
      let dropDownYear;
      if(currentmonth <3){
        dropDownYear = (currentYear - 1) + '-'+ currentYear;
      } else{
        dropDownYear = currentYear + '-'+ (currentYear + 1);
      }      
      this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
        this.yearDropDownList = data['data'];
      });
      this.editweightfilter['ay'] = dropDownYear;
      this.abstractYear = this.editweightfilter['ay'].split('-');
      // this.currentYearVar = currentYear;
    }
  setCurrentMonthDefault() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.editweightfilter['month'] = currentmonthObj['key'];
    // this.currentMonthVar = currentmonthObj['value'];
  }
    getAssesmentYear(){
      this.statehierachyDataList['AssesmentList'] = this.submitdataSerivce.getassesmentYear();
    } 
    getstateslist(){
      let postdata = {};
      this.stateArrayList = [];
      this.statelists = [];
      postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
      postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
      postdata["component"] = "";
      postdata["src"] = "";
      this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
        if(data){
           this.statelists = [];
             Object.keys(data).forEach(key =>{
              data[key].forEach(statelist => {
              if(statelist['uuid'] == this.userdetails['loggedUserData']['userProfile']['stateUUID']){
                this.statelists.push(statelist);
                this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
              }
  
            });
          })
        }
      });
    
    }
    closeModal(){
      this.modalReference.dismiss(this.meetingModal)
    }
   
    fetchtableData(){
      if(this.showDrop == 'monthwise' || this.showDrop == "statewise"){
        this.attendenceReport=[];
        this.showAttendence=true;
        this.showtabledata = true;
      let obj = {
        "ay" : this.editweightfilter['ay'],
        "subTp" : this.editweightfilter['month'],
        "pu" :this.userdetails['loggedUserData']['userProfile']['stateUUID'],
        "mode":"dgc"
      };
      let obj1 = {
        "ay" : this.editweightfilter['ay'],
        "subTp" : this.editweightfilter['month'],
        "pu" :this.userdetails['loggedUserData']['userProfile']['stateUUID'],
        "locationName":this.userdetails['loggedUserData']['userProfile']['locationName']
      };
       
      this.submitdataSerivce.getDistReportData(obj).subscribe(distdata =>{
        this.availabledistdata = [];
          this.fetchdistricts = distdata;
          this.formatbackendData(distdata);
          this.formatstateMeetingData();
      });
      this.respectiveMonthYear();
      } else if(this.showDrop == 'reportsummary'){
        let currentmonth = new Date().getMonth()
        let currentmonthObj;
        this.monthsList.forEach(monthObj =>{
          if(parseInt(monthObj['key'])  == currentmonth + 1){
            currentmonthObj = monthObj;
          }
        });
        this.selectedFilter = currentmonthObj['key'];
        let postdata = {};
        postdata['ay'] = this.editweightfilter['ay'];
        postdata['subTp'] = this.selectedFilter;
        postdata['pu'] = this.userdetails['loggedUserData']['userProfile']['stateUUID'];
        postdata['mode'] = "dgc";
        this.submitdataSerivce.downloadReportSummary(postdata).subscribe(result =>{
          let filename: string =  "ReportSummary";
        var newBlob = new Blob([result], { type: "application/pdf" });
        const data = window.URL.createObjectURL(newBlob);
        
        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
        })
      } else if(this.showDrop == 'consolidatedreport'){
        this.showtabledata = true;
        let postdata ={
            "ay": this.editweightfilter['ay'],
            "subTp": this.editweightfilter['month'],
            "ts": new Date().getTime(),
            "pu": "f78f615d-e270-4f93-90ac-27608e756b85",
            "userId": this.userdetails['loggedUserData']['userProfile']['userId'],
            "view": "admin",
            "component": 1,
            "cType": this.constants.LOCATION_CONSTANT.STATE
        }
        this.submitdataSerivce.fetchConsolidatedMeetingReport(postdata).subscribe(data=>{
          if(!isNullOrUndefined(data)){
            this.fetchconsolidatedReports(data);
          }
        })
      } else if(this.showDrop == 'abstractreport'){
       this.showtabledata = true;
        let postdata = {
          "ay": this.editweightfilter['ay'],
          "monthList": this.submitdataSerivce.getMonthList()
        }
        this.submitdataSerivce.getAbstractReport(postdata).subscribe(res =>{
          if(res.status)
          this.formatAbstractData(res['data']);        
        })
        this.respectiveMonthYear();
      }
    } 

    formatAbstractData(data: any) {
      this.abstractRepData = [];
      const stateName = this.userdetails['loggedUserData']['userProfile']['locationName'];
      let totalEntry = null;
    
      // Loop over all keys
      Object.keys(data).forEach(key => {
        if (key === 'dgcCount') {
          this.dgcCount = (data[key] && data[key][stateName]) ? data[key][stateName] : null;
        } else if (key === '0') {
          // Store total to add later
          totalEntry = data[key];
        } else {
          const stateData = data[key] && data[key][stateName];
          if (stateData !== undefined) {
            this.abstractRepData.push({
              month: this.formatMonth(key),
              statereports: stateData
            });
          }
        }
      });
    
      // Push total at the end, if available
      if (totalEntry && totalEntry[stateName] !== undefined) {
        this.abstractRepData.push({
          month: 'Total',
          statereports: totalEntry[stateName]
        });
      }
    }
    
    formatMonth(monthKey: string): string {
      if (monthKey.length !== 6) return monthKey;
      const year = +monthKey.substring(0, 4);
      const month = +monthKey.substring(4) - 1;
      return new Date(year, month).toLocaleString('default', { month: 'long', year: 'numeric' });
    }    
    
    
    fetchconsolidatedReports(data){
      this.fetchReport =[];
      if(!isNullOrUndefined(data)){
        if(this.userdetails['login'] == "sgc_bh"){
          Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
            if(key == "BIHAR"){
              this.parseobj = value;
              let parseArray = JSON.parse(this.parseobj);
              let item ={};
              if(this.parseobj!=null){
                item['stateName'] = key;
                item['uuid'] = parseArray['fileUUID'];
                item['date'] = this. formatDate(parseArray['dateofSubmission'])
                this.fetchReport.push(item);
              }
            }
          })
        } else if(this.userdetails['login'] == "sgc_uk"){
          Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
            if(key == "UTTARAKHAND"){
              this.parseobj = value;
              let parseArray = JSON.parse(this.parseobj);
              let item ={};
              if(this.parseobj!=null){
                item['stateName'] = key;
                item['uuid'] = parseArray['fileUUID'];
                item['date'] = this. formatDate(parseArray['dateofSubmission'])
                this.fetchReport.push(item);
              }
            } 
          })
        } else if(this.userdetails['login'] == "sgc_up"){
          Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
            if(key == "UTTAR PRADESH"){
              this.parseobj = value;
              let parseArray = JSON.parse(this.parseobj);
              let item ={};
              if(this.parseobj!=null){
                item['stateName'] = key;
                item['uuid'] = parseArray['fileUUID'];
                item['date'] = this. formatDate(parseArray['dateofSubmission'])
                this.fetchReport.push(item);
              }
            }
          })
        } else if(this.userdetails['login'] == "sgc_wb"){
          Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
            if(key == "WEST BENGAL"){
              this.parseobj = value;
              let parseArray = JSON.parse(this.parseobj);
              let item ={};
              if(this.parseobj!=null){
                item['stateName'] = key;
                item['uuid'] = parseArray['fileUUID'];
                item['date'] = this. formatDate(parseArray['dateofSubmission'])
                this.fetchReport.push(item);
              } 
            }
          })
        } else if(this.userdetails['login'] == "sgc_jh"){
          Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
            if(key == "JHARKHAND"){
              this.parseobj = value;
              let parseArray = JSON.parse(this.parseobj);
              let item ={};
              if(this.parseobj!=null){
                item['stateName'] = key;
                item['uuid'] = parseArray['fileUUID'];
                item['date'] = this. formatDate(parseArray['dateofSubmission'])
                this.fetchReport.push(item);
              }
            } 
          })
        }
      }
    }
    formatDate(inputDate : any){
      if(inputDate != String){
        inputDate = inputDate.toString();      
      }
      let year = inputDate.substring(0,4);
      let month = inputDate.substring(4,6);
      let date = inputDate.substring(6,8);
      let monthLabl;
      if(inputDate.length == 6){      
      this.monthsList.forEach(mon => {
        if(month == mon['key']){          
          monthLabl = mon['value'];          
        }
      });      
      // if(month == '04' || month == '05'){
      //   year1 = year-1;        
      // }
      // let newDate = monthLabl + "-" + year1;         
      return monthLabl;
      } else{
      let newDate = date + "-" + month +"-" + year;
      return newDate;
      }
    }
    
    downloadConsolidatedReport(uuid){
      let data ={
        "fileUUID" : uuid
      }
      this.activeSpinner = true;
      this.submitdataSerivce.downloadExcel(data).subscribe(data=>{
        this.activeSpinner = false;
        let filename: string =  "ConsolidatedReportSummary";
        var newBlob = new Blob([data], { type: "application/pdf" });
        const result = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = result;
        link.download = filename;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
      });
    }
  formatbackendData(distdata: any) {
    Object.keys(distdata).forEach(element =>{
      Object.keys(distdata[element]).forEach(uuid =>{
        let stateobj = {};
        stateobj['name'] = distdata[element][uuid]['distName'];
        stateobj['id'] = distdata[element][uuid]['id'];
        stateobj['state'] = distdata[element][uuid]['state'];
        stateobj['uuid'] = distdata[element][uuid]['stateUUID'];
        stateobj['date'] = distdata[element][uuid]['Date'];
        stateobj['dateofMeeting'] = distdata[element][uuid]['dateofMeeting'];
        this.availabledistdata.push(stateobj);
      })
    })
    this.availabledistdata.sort((a,b)=>
    b.date-a.date
    ) 
      
  }
  sortRows(property){
    this.isDescending = !this.isDescending;
    let direction = this.isDescending ? 1 : -1;

    this.availabledistdata.sort(function(a,b){
    if (a[property] < b[property]) {
      return -1 * direction;
    }
    else if (a[property] > b[property]) {
      return 1 * direction;
    }
    else {
      return 0;
    }
   });
    
  }
  openmeetingWindow(){
    this.modalReference = this.modalService.open(this.meetingModal,{windowClass:'modal-table-popup'});
    this.modalReference.result.then((result) => {
    }, (reason) => {
    });
    
  }
  formatstateMeetingData(){
    let obj = {
      "ay" : this.editweightfilter['ay'],
      "subTp" : this.editweightfilter['month'],
      "pu" :this.userdetails['loggedUserData']['userProfile']['stateUUID'],
      "locationName":this.userdetails['loggedUserData']['userProfile']['locationName'],
      "cType" : this.constants.LOCATION_CONSTANT.DISTRICT,
      "lu":this.userdetails['loggedUserData']['userProfile']['locationId'],
      "mode" : "dgc"
    };
    this.submitdataSerivce.getAttendantReport(obj).subscribe(data =>{
      this.attendenceReport = [];
      this.clickableData = data;
      if(data.length > 0){
        let item = {};
        item['to'] = data['attendant'][0];
        item['att'] = data['attendant'][1];
        item['non'] = data['attendant'][2];
        this.attendenceReport.push(item);
      }
     
    });
  }
  getDateandTimeString(timestamp, format) {
    var d = new Date(Number(timestamp));
    var year = d.getFullYear();
    var month: any = d.getMonth() + 1;
    month = month.toString();
    var date = d.getDate().toString();
    var hours = d.getHours().toString();
    var minutes = d.getMinutes().toString();
    var seconds = d.getSeconds().toString();
    if (month.length < 2) month = '0' + month;
    if (date.length < 2) date = '0' + date;
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;
    var str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
    switch (format) {
      case "DD-MM-YYYY HH:mm:ss":
        str = date + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
        break;
      case "YYYY-MM-DD hh:mm:ss":
        str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
        break;
      case "YYYY-MM-DD hh:mm":
        str = year + "-" + month + "-" + date + " " + hours + ":" + minutes;
        break;
      case "YYYY-MM-DD":
        str = year + "-" + month + "-" + date
        break;
      case "DD-MM-YYYY":
        str = date + "-" + month + "-" + year
        break;
      case "YYYYMMDD":
        str = year.toString()+month.toString()+date.toString()
        break;
      case "YYYYMM":
        str = year.toString()+month.toString()
        break;
      case "YYYY":
        str = year.toString()
        break;
    }

    return str;
  }
  fetchTableData(){
    this.showtabledata = true;
    let tabledata = {
      "ay" : this.editweightfilter['ay'],
      "view" : this.constants.VIEWS['admin'],
      "component": 1,
      "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
      "lu" : this.districtid,
      "subTp" : this.editweightfilter['month'],
      "userId" : "1"
    }
    this.submitdataSerivce.getrawdata(tabledata).subscribe(rawdata =>{
      this.formatTableData(rawdata)
    })
  }
  formatTableData(rawdata){
    this.hierarchyData = [];
    Object.keys(rawdata['buzdata']).forEach(theme => {
      let index = 0;
      Object.keys(rawdata['buzdata'][theme]).forEach(loc => {
        let item  = {};
        index=index+1;
        item['name'] = this.subindicatorlabel[rawdata['buzdata'][theme][loc]['id']];
        item['val'] = rawdata['buzdata'][theme][loc]['value'];
        this.hierarchyData.push(item);
      })
    });

  }
  respectiveMonthYear(){
    this.monthsList.forEach(month => {
      if(this.editweightfilter['month'] == month['key']){
        this.currentMonthVar = month['value']
      }
    });

    this.yearList.forEach(year => {
      if(this.editweightfilter['ay'] == year['value']){
        this.currentYearVar = year['key']

      }
    })
    let yearVar;
    yearVar = this.editweightfilter['ay'].split('-');

    if(this.editweightfilter['month'] < 4){
      this.selectedYear = yearVar[1];
    }else{
      this.selectedYear = yearVar[0];
    }
    this.abstractYear = this.editweightfilter['ay'].split('-');
  }
  downloadFile(uuid,distname){
    this.monthsList.forEach(month => {
      if(this.editweightfilter['month'] == month['key']){
        this.monthLabel = month['value']
      }
    });
    let postdata = {
      "ay" : this.editweightfilter['ay'],
      "view" : this.constants.VIEWS['admin'],
      "component": 1,
      "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
      "lu" : uuid,
      "subTp" : this.editweightfilter['month'],
      "userId" : "1"
    }
    this.submitdataSerivce.downloadrawData(postdata).subscribe(result => {
      let filename: string =  distname+"district Meeting report"+"_"+this.editweightfilter['ay'] + this.monthLabel;
      var newBlob = new Blob([result], { type: "application/pdf" });
      const data = window.URL.createObjectURL(newBlob);
      
      var link = document.createElement('a');
      link.href = data;
      link.download = filename;
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      
      setTimeout(function () {
          window.URL.revokeObjectURL(data);
          link.remove();
      }, 100);
  });
  }
  downloadMRS(statename){
    
  }
  infoClick(tableobj,id,name){
    this.modalRef = this.modalService.open(ViewmodalReportComponent,{backdrop: 'static',size: 'lg',windowClass: 'backgroundTransparent  approvalinfo'});
    this.modalRef.componentInstance.weightdata = tableobj;
    this.modalRef.componentInstance.ay = this.editweightfilter['ay'];
    this.modalRef.componentInstance.subtimeperiod = this.editweightfilter['month'];
    this.modalRef.componentInstance.distname = name;
    this.modalRef.componentInstance.distuuid = id;
    this.modalRef.result.then((result) => {
      if(result == 'load')
        this.fetchTableData();
    }, (reason) => {
  
    });
    
  }
  formatdate(date){
    return this.utils.getDateInFormatFromModelDate(date.toString(),"dd-MM-yyyy")

  }
  showdropdown(selectedMode){
    this.showDrop = selectedMode;
    this.showtabledata = false;
  }

  printReport(type){
    if(type == "abstractreport"){
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 50;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        // console.log(canvas.height+"  "+canvas.width);        
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        // var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        var pdf = new jsPDF('l', 'mm', [1100 , 650]);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);   
        pdf.addImage(imgData, 'JPG', 40 , 40 , 1020 , 530 );  
        pdf.save("AbstractReport.pdf");
      });
    } else if (type == "monthwise") {
      let postdata = {
        "ay": this.editweightfilter['ay'],
        "subTp": this.editweightfilter['month'],
        "pu": this.userdetails['loggedUserData']['userProfile']['stateUUID'],
        "mode" : 'dgc'
      }
      this.submitdataSerivce.downloadMeetingReports(postdata).subscribe(result => {
        let filename: string = "MeetingReport";
        var newBlob = new Blob([result], { type: "application/pdf" });
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(function () {
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      })
    }
    this.activeSpinner = false;
  }
   
}
